const settings = {
    SERVER_URL: window.env.SERVER_URL,
    TITLE: window.env.TITLE,
    FB_APP_ID: window.env.FB_APP_ID
};

export default settings;